import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post, put, del } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

/**
 * System lists → SaaS module tab: master list `GET /clients/saas-modules`.
 */
export const fetchSaasMasterModules = createAsyncThunk(
  "saasMasterModules/fetchList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.CLIENTS.GET_SAAS_MODULES);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch SaaS modules"));
    }
  }
);

/**
 * `POST /clients/saas-modules` — body `{ name, sortOrder, isActive }`.
 */
export const createSaasMasterModule = createAsyncThunk(
  "saasMasterModules/create",
  async ({ name, sortOrder, isActive }, { rejectWithValue }) => {
    try {
      const response = await post(API_ENDPOINTS.CLIENTS.GET_SAAS_MODULES, {
        name: String(name ?? "").trim(),
        sortOrder: Number.isFinite(Number(sortOrder)) ? Number(sortOrder) : 0,
        isActive: Boolean(isActive),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to create SaaS module"));
    }
  }
);

/**
 * `PUT /clients/saas-modules/:id` — body `{ name, sortOrder, isActive }`.
 */
export const updateSaasMasterModule = createAsyncThunk(
  "saasMasterModules/update",
  async ({ id, name, sortOrder, isActive }, { rejectWithValue }) => {
    try {
      const response = await put(API_ENDPOINTS.CLIENTS.UPDATE_SAAS_MASTER_MODULE(String(id)), {
        name: String(name ?? "").trim(),
        sortOrder: Number.isFinite(Number(sortOrder)) ? Number(sortOrder) : 0,
        isActive: Boolean(isActive),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to update SaaS module"));
    }
  }
);

/**
 * `DELETE /clients/saas-modules/:id`
 */
export const deleteSaasMasterModule = createAsyncThunk(
  "saasMasterModules/delete",
  async (id, { rejectWithValue }) => {
    try {
      await del(
        API_ENDPOINTS.CLIENTS.DELETE_SAAS_MASTER_MODULE(String(id)),
        {},
        { skipToast: true }
      );
      return String(id);
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to delete SaaS module"));
    }
  }
);
